module.exports = __webpack_public_path__ + "static/media/massbygg.1af13c13.jpg";